export default __webpack_public_path__ + "static/media/navigatingunitsofstudy.bf680744.svg";